import {useState} from "react";
import {useFormContext} from "react-hook-form";

import {Alert} from "@/components/alert/Alert.tsx";
import Button from "@/components/button/Button.tsx";
import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {MaintenanceSchedule, MaintenanceScheduleState} from "@/lib/types/maintenance.ts";
import {getScheduleState} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/MaintenanceSchedulesTable.utils.ts";

interface DisconnectScheduleActionProps {
  schedule: MaintenanceSchedule;
}

export const DisconnectScheduleAction = ({schedule}: DisconnectScheduleActionProps) => {
  const [show, setShow] = useState(false);
  const {watch, setValue} = useFormContext();
  const maintenanceScheduleIds: number[] = watch(ServiceField.MAINTENANCE_SCHEDULE_IDS) || [];
  const scheduleState = getScheduleState(schedule);
  return (
    <>
      <Button variant={"secondary"} onClick={() => setShow(true)}>
        Disconnect
      </Button>
      <DeleteActionDialog
        show={show}
        title="Disconnect Schedule"
        onConfirm={() => {
          const newIds = maintenanceScheduleIds.filter((id) => id !== schedule.id);
          setValue(ServiceField.MAINTENANCE_SCHEDULE_IDS, newIds, {shouldDirty: true});
          setShow(false);
        }}
        onCancel={() => {
          setShow(false);
        }}
      >
        {scheduleState === MaintenanceScheduleState.IN_MAINTENANCE && (
          <Alert variant={"maintenance"}>
            Disconnecting this Schedule may cause the Check to resume normal operations.
          </Alert>
        )}
        Are you sure you want to disconnect the Maintenance Schedule{" "}
        <span className="pulseTextBodyBold">{schedule.name}</span> from this Check? This will not impact the Schedule
        itself and can be linked again.
      </DeleteActionDialog>
    </>
  );
};
